import { useState } from 'react';
import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserCardType } from '~/types/paymentTypes';
import MobileCardItem from '~myAccount/pages/UserCards/MobileCardItem';
import DesktopCardItem from '~myAccount/pages/UserCards/DesktopCardItem';
import { useGetUserCardsQuery } from '~/redux/api/userApiSlice';
import { RoutesEnum } from '~/constants/enums';
import PageLayout from '~myAccount/components/PageLayout';
import CardDeleteModal from '~myAccount/pages/UserCards/CardDeleteModal';
import ListLoader from '~/components/ListLoader';
import useBreakpoint from '~/hooks/useBreakpoint';
import '~myAccount/pages/UserCards/styles.css';

const UserCards = () => {
  const { t } = useTranslation('app');
  const navigate = useNavigate();
  const { mobileScreen } = useBreakpoint();
  const [deleteId, setDeleteId] = useState<number>(0);
  const { data: responseData, isLoading } = useGetUserCardsQuery();
  const cards: UserCardType[] = responseData?.data;
  const hasSavedCards = cards?.length !== 0;
  const cardsLimit = 3;

  return (
    <PageLayout
      bodyClassName="border border-gray rounded-[8px]"
      title={t('savedCards')}
      subTitle={
        <Trans
          i18nKey="addLimit"
          t={t}
          values={{ number: cardsLimit }}
          components={{
            tag: <span className="font-bold">placeholder</span>,
          }}
        />
      }
      ctas={
        hasSavedCards ? (
          <Button
            size="small"
            variant="primary"
            disabled={cards?.length >= cardsLimit}
            onClick={() => {
              navigate(RoutesEnum.USER_ADD_CARD);
            }}
          >
            {t('addCard')}
          </Button>
        ) : null
      }
    >
      {isLoading ? (
        <ListLoader height={30} count={3} />
      ) : !hasSavedCards ? (
        <div className="flex flex-col gap-2x items-center p-2x md:p-4x  h-full md:h-auto">
          <Icon name="visa" size="80" className="text-gray__dark_1" />
          <p className="text-body_2 text-gray__dark_2 w-auto md:w-[221px] text-center">
            {t('noCardsAdded')}
            <br />
            <span className="text-black"> {t('addCardsForEasyPay')}</span>
          </p>
          <Button
            variant="primary"
            size="medium"
            className="w-full md:w-[343px]"
            onClick={() => navigate(RoutesEnum.USER_ADD_CARD)}
          >
            {t('addCard')}
          </Button>
        </div>
      ) : (
        <>
          {cards?.map((card, index) => {
            return mobileScreen ? (
              <MobileCardItem
                isLast={index === cards.length - 1}
                card={card}
                onDeleteItem={(id: number) => setDeleteId(id)}
              />
            ) : (
              <DesktopCardItem
                isLast={index === cards.length - 1}
                card={card}
                onDeleteItem={(id: number) => setDeleteId(id)}
              />
            );
          })}

          <CardDeleteModal id={deleteId} />
        </>
      )}
    </PageLayout>
  );
};

export default UserCards;
